import React from 'react'
import GalleryComponent from '../../components/GalleryComponent/GalleryComponent'
import SafariBlog from '../../components/SafariBlog/SafariBlog'

import safariBlog_1 from '../../assets/images/wildlife-safari-1.jpeg'
import safariBlog_2 from '../../assets/images/wildlife-safari-2.jpeg'
import safariBlog_3 from '../../assets/images/wildlife-safari-3.webp'
import safariBlog_4 from '../../assets/images/wildlife-safari-4.webp'
import safariBlog_5 from '../../assets/images/wildlife-safari-5.jpg'
import safariBlog_6 from '../../assets/images/wildlife-safari-6.jpg'
import safariBlog_7 from '../../assets/images/wildlife-safari-7.jpeg'
import safariBlog_8 from '../../assets/images/wildlife-safari-8.webp'
import safariBlog_9 from '../../assets/images/wildlife-safari-9.webp'
import safariBlog_10 from '../../assets/images/wildlife-safari-10.webp'
import safariBlog_11 from '../../assets/images/wildlife-safari-11.webp'


const descriptions = [
    'Join us on a special trip where you can learn all about wildlife photography. Our Customized Wildlife Photography Learning Tour is designed for photographers of any skill level, whether you’re just starting out or you’re already experienced. Led by experienced guides, you’ll explore different natural areas and take pictures of beautiful landscapes and animals. This hands-on experience includes photography lessons from experts, so you’ll not only get great photos but also learn a lot. Whether you’re photographing big cats or tiny insects, this tour will be an exciting adventure into the world of wildlife photography.',
  ];

const wildlife_photography = () => {

    const items = [
        { xs: 3, imgSrc: safariBlog_1 },
        { xs: 5, imgSrc: safariBlog_2 },
        { xs: 4, imgSrc: safariBlog_3 },
        { xs: 3, imgSrc: safariBlog_4 },
        { xs: 3, imgSrc: safariBlog_5 },
        { xs: 3, imgSrc: safariBlog_6 },
        { xs: 3, imgSrc: safariBlog_7 },
        { xs: 2.5, imgSrc: safariBlog_8 },
        { xs: 4.5, imgSrc: safariBlog_9 },
        { xs: 2.5, imgSrc: safariBlog_10 },
        { xs: 2.5, imgSrc: safariBlog_11 },
    ];

  return <div className='__black'>
    <SafariBlog
        heading='Customized Wildlife Photography Learning Tour'
        description={descriptions}
        to='/contact'
    />
    <div className="w-1">
        <GalleryComponent imgStyle={{padding:'10px', height:'50vh'}} items={items} />;
    </div>
  </div>
}

export default wildlife_photography